import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export enum SectionSelectedState {
    Unselected,
    SomeSelected,
    AllSelected
}

@Component({
    selector: 'studio-list-section',
    templateUrl: './studio-list-section.component.html',
    styleUrls: ['./studio-list-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudioListSectionComponent {
    @Input({ required: true }) selected: SectionSelectedState = SectionSelectedState.Unselected;
    @Output() toggleAll = new EventEmitter<boolean>();

    collapsed = false;
    SectionSelectedState = SectionSelectedState;

    onToggleAll(): void {
        const newState = this.selected !== SectionSelectedState.AllSelected;
        this.toggleAll.emit(newState);
    }

    onCollapseHeader(event: MouseEvent, checkbox: HTMLElement): void {
        // do nothing if clicked element is the checkbox or a descendant of it
        const isNode = event.target instanceof Node;
        if (isNode && (event.target === checkbox || checkbox.contains(event.target))) {
            return;
        }
        this.collapsed = !this.collapsed;
    }
}
